module.exports = __webpack_public_path__ + "img/img-intp.a8e194d4.jpg";